<template>
  <NuxtLayout />
</template>

<script setup lang="ts">
const i18nHead = useLocaleHead({ seo: true })

useHead(() => ({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang,
    dir: i18nHead.value.htmlAttrs?.dir as 'ltr' | 'rtl' | 'auto' | undefined,
  },
  link: [...(i18nHead.value.link ?? [])] as never[],
  meta: [...(i18nHead.value.meta ?? [])] as never[],
}))
</script>
